import { atom } from "jotai";

export const page_title = atom("");
